module.exports = __webpack_public_path__ + "static/media/hydropartners.f7340574.jpg";